import { FC } from 'react';
import FormErrorsPreviewErrorTarget from '../../../modules/detailPage/components/FormErrorsPreview/FormErrorsPreviewErrorTarget';
import { isString } from '../../../predicates/string';
import ControlGroup from '../../ControlGroup';
import { FormFieldAdapterProps } from '../../CustomForm';
import { PartiallyRequiredWrapper } from '../../PartiallyRequired/PartiallyRequiredWrapper';
import { TextBoxProps, TextBoxWithPreview } from '../../Textbox';
import textboxClasses from '../../Textbox/styles/index.module.scss';
import { ValidationMessage } from '../../ValidationMessage';
import { getDisabledProp } from '../utils';
import { getPartiallyRequiredFilledProp, getPreviewModeProp } from '../../CustomForm/adapters/utils/base';

// @ts-ignore
type TextboxAdapterProps = FormFieldAdapterProps<TextBoxProps>;

const TextboxAdapter: FC<TextboxAdapterProps> = (props) => {
	const {
		input,
		meta: { invalid, touched, error },
		partiallyRequired,
		partiallyRequiredFilled: partiallyRequiredFilledFromProps = true,
		metadata,
		controlProps,
		componentProps,
		previewProps = {},
		previewMode,
	} = props;
	const { value, name, onChange, onFocus, onBlur } = input;
	const showValidation = props.immediateValidation ? invalid : invalid && touched;
	const partiallyRequiredFilled = getPartiallyRequiredFilledProp({
		partiallyRequiredFilled: partiallyRequiredFilledFromProps,
		value,
	});

	return (
		<ControlGroup
			{...controlProps}
			previewMode={previewMode}
			valid={!showValidation}
			validationMessage={<ValidationMessage keyCode={error} />}
			partiallyRequired={partiallyRequired}
			partiallyRequiredFilled={partiallyRequiredFilled}
		>
			<FormErrorsPreviewErrorTarget targetName={name}>
				<PartiallyRequiredWrapper
					partiallyRequired={partiallyRequired}
					partiallyRequiredFilled={partiallyRequiredFilled}
					invalid={componentProps?.invalid}
					className={componentProps?.className}
					partiallyRequiredClass={textboxClasses.textbox_partiallyRequired}
				>
					{({ wrapperClassName }) => (
						<TextBoxWithPreview
							{...previewProps}
							{...componentProps}
							className={wrapperClassName}
							previewMode={getPreviewModeProp({
								metadataPreviewMode: metadata?.previewMode,
								previewMode: props.previewMode,
							})}
							disabled={getDisabledProp({
								metadataDisabled: metadata?.disabled,
								disabled: props.disabled,
							})}
							name={name}
							value={value}
							invalid={showValidation}
							onChange={onChange}
							onFocus={onFocus}
							onBlur={() => (isString(value) ? onBlur(value.trim()) : onBlur(value))}
						/>
					)}
				</PartiallyRequiredWrapper>
			</FormErrorsPreviewErrorTarget>
		</ControlGroup>
	);
};

export { TextboxAdapter };
export default TextboxAdapter;
